import { IState } from 'legacy/lut/store'
import { createSelector } from 'reselect'

export const createSelectPartnerProperty = (fieldName: string) =>
  createSelector(
    (state: IState) => state.partner,
    (partner) => partner.partnerData.data?.[fieldName]
  )
